<script setup lang="ts">
defineProps<{
  selected?: boolean;
  hideBorder?: boolean;
}>();
</script>
<template>
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      :class="{
        'fill-accent stroke-neutral': selected,
        hidden: hideBorder
      }"
      x="1"
      y="2"
      width="38"
      height="38"
      rx="3"
      fill="#021B27"
    />
    <rect
      :class="{
        'fill-accent stroke-neutral': selected,
        hidden: hideBorder
      }"
      x="1"
      y="2"
      width="38"
      height="38"
      rx="3"
      stroke="#02877F"
      stroke-width="2"
    />
    <path
      d="M7.2002 14.5523C7.2002 14 7.64791 13.5523 8.2002 13.5523H22.529C22.7214 13.5523 22.8417 13.7605 22.7457 13.9271L17.3074 23.3663C17.2367 23.4889 17.1929 23.6245 17.1821 23.7656C17.1139 24.6609 16.9221 28.1741 17.8933 30.4459C18.0548 30.8237 18.4672 31.0113 18.8675 30.9193C21.2153 30.3797 23.6852 29.1045 24.456 28.6871C24.6166 28.6002 24.7471 28.4679 24.8358 28.3083L26.7317 24.8957C26.8569 24.6702 27.2002 24.7591 27.2002 25.0171V32.5523C27.2002 33.1046 26.7525 33.5523 26.2002 33.5523H8.2002C7.64791 33.5523 7.2002 33.1046 7.2002 32.5523V14.5523Z"
      fill="#00CAAA"
    />
    <path
      d="M10.2002 17.5523C10.2002 17 10.6479 16.5523 11.2002 16.5523H18.2002C18.7525 16.5523 19.2002 17 19.2002 17.5523C19.2002 18.1046 18.7525 18.5523 18.2002 18.5523H11.2002C10.6479 18.5523 10.2002 18.1046 10.2002 17.5523Z"
      fill="#021B27"
    />
    <path
      d="M10.2002 21.5523C10.2002 21 10.6479 20.5523 11.2002 20.5523H15.7002C16.2525 20.5523 16.7002 21 16.7002 21.5523C16.7002 22.1046 16.2525 22.5523 15.7002 22.5523H11.2002C10.6479 22.5523 10.2002 22.1046 10.2002 21.5523Z"
      fill="#021B27"
    />
    <path
      d="M10.2002 29.5523C10.2002 29 10.6479 28.5523 11.2002 28.5523H15.2002C15.7525 28.5523 16.2002 29 16.2002 29.5523C16.2002 30.1046 15.7525 30.5523 15.2002 30.5523H11.2002C10.6479 30.5523 10.2002 30.1046 10.2002 29.5523Z"
      fill="#021B27"
    />
    <path
      d="M10.2002 25.5523C10.2002 25 10.6479 24.5523 11.2002 24.5523H15.2002C15.7525 24.5523 16.2002 25 16.2002 25.5523C16.2002 26.1046 15.7525 26.5523 15.2002 26.5523H11.2002C10.6479 26.5523 10.2002 26.1046 10.2002 25.5523Z"
      fill="#021B27"
    />
    <path
      d="M27.437 8.41844C27.7132 7.94015 28.3247 7.77627 28.803 8.05242L32.6153 10.2534C33.0936 10.5296 33.2575 11.1412 32.9813 11.6195L30.8138 15.3737C30.8138 15.3737 29.623 15.3022 27.7749 14.2352C27.4358 14.0394 27.1367 13.846 26.8745 13.6607C27.3844 12.7777 28.1846 11.3916 28.7181 10.4675C28.9849 10.0055 28.0608 9.472 27.7941 9.93402C27.5273 10.3961 26.4603 12.2442 26.0295 12.9904C25.4886 12.5045 25.2695 12.1727 25.2695 12.1727L27.437 8.41844Z"
      fill="#00CAAA"
    />
    <path
      d="M24.7359 13.097C24.7359 13.097 24.955 13.4288 25.4958 13.9147C25.1264 14.5545 20.0581 23.333 19.7914 23.7951C19.5246 24.2571 19.6484 26.1767 20.1819 25.2526C20.7154 24.3286 26.1241 14.9605 26.3409 14.585C26.6031 14.7703 26.9021 14.9637 27.2413 15.1595C29.0894 16.2265 30.2802 16.298 30.2802 16.298C30.2802 16.298 24.1449 26.9246 23.8782 27.3866C23.6114 27.8486 19.434 29.7491 18.972 29.4823C18.51 29.2156 18.0671 24.6476 18.3338 24.1856C18.6006 23.7236 24.7359 13.097 24.7359 13.097Z"
      fill="#00CAAA"
    />
  </svg>
</template>
